export function isAnalysisInterval(x: any): x is Bera.DateInterval {
  const valid = ['weekly', 'monthly', 'quarterly', 'yearly'];

  return valid.includes(x);
}
